/** Documents — create form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  CONFIDENTIALITY,
  createDocumentSchema,
  type CreateDocumentInput,
} from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader } from "../projects/_shared";
import {
  FormGrid,
  MarkdownField,
  SelectField,
  TextField,
} from "../projects/_form";

export function DocumentCreate() {
  const form = useForm<CreateDocumentInput, any, CreateDocumentInput>({
    resolver: zodResolver(createDocumentSchema),
    defaultValues: {
      title: "",
      source_system: "",
      external_url: "",
      document_type: "",
      confidentiality: "internal",
      canonical_status: "active",
      project_id: "",
      owner_user_id: "",
      agent_summary: "",
      last_reviewed_at: "",
    },
    refineCoreProps: { resource: "documents", action: "create" },
  });

  const {
    refineCore: { formLoading },
    saveButtonProps,
    control,
  } = form;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader
        title="New Document"
        description="Register an external document in the operating core."
        icon="documents"
      />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Document details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <TextField
                control={control}
                name="title"
                label="Title"
                placeholder="Geotechnical report"
              />
              <FormGrid>
                <TextField
                  control={control}
                  name="source_system"
                  label="Source system"
                  placeholder="sharepoint"
                  description="Where the document lives."
                />
                <TextField
                  control={control}
                  name="document_type"
                  label="Document type"
                  placeholder="report"
                />
                <TextField
                  control={control}
                  name="external_url"
                  label="External URL"
                  placeholder="https://…"
                  description="Link to the source document."
                />
                <SelectField
                  control={control}
                  name="confidentiality"
                  label="Confidentiality"
                  options={CONFIDENTIALITY}
                />
                <TextField
                  control={control}
                  name="project_id"
                  label="Project ID"
                  placeholder="prj_…"
                />
                <TextField
                  control={control}
                  name="owner_user_id"
                  label="Owner User ID"
                  placeholder="user_…"
                />
              </FormGrid>
              <MarkdownField
                control={control}
                name="agent_summary"
                label="Agent summary"
                placeholder="Markdown summary used by agents…"
                description="Agent-readable markdown summary of the document."
              />
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Creating…" : "Create Document"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default DocumentCreate;
